<script>
import { clientProgramComputed, clientProgramMethods } from '@state/helpers';

export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {
    ...clientProgramComputed,
    textContent() {
      const toWorkout = this.dragModalCtx.targetedDataClone.day.workouts[0];
      const fromWorkout = this.dragModalCtx.destinationDataClone.day
        .workouts[0];
      return {
        main: `Do you want to replace ${fromWorkout.label} with ${toWorkout.label}?`,
        confirmButton: 'Yes, Replace Workout',
        cancelButton: 'No, Don’t Replace',
      };
    },
  },
  mounted() {},
  methods: {
    ...clientProgramMethods,
    async confirm() {
      await this.setDragModalCtx({ ...this.dragModalCtx, confirm: true });
      this.$bvModal.hide('drag-confirmation-modal');
    },
    close(e) {
      this.setDragModalCtx(null);
      this.$bvModal.hide('drag-confirmation-modal');
    },
  },
};
</script>

<template class="modal-confirmation">
  <b-modal
    id="drag-confirmation-modal"
    centered
    :hide-footer="true"
    @close="close"
  >
    <template v-if="dragModalCtx" slot="default">
      <div>
        <p class="modal-text-main">{{ textContent.main }}</p>
        <div class="actions">
          <BaseButton class="btn-secondary btn-round" @click="close">
            {{ textContent.cancelButton }}
          </BaseButton>
          <BaseButton class="btn-primary btn-round" @click="confirm">
            <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.876.4H2.296C1.053.4.034 1.43.034 2.69v16.037h2.264V2.691h13.579V.4zm3.394 4.582H6.823c-1.245 0-2.263 1.03-2.263 2.29V23.31c0 1.26 1.018 2.291 2.263 2.291H19.27c1.245 0 2.264-1.03 2.264-2.29V7.272c0-1.26-1.019-2.291-2.264-2.291zM6.823 23.309H19.27V7.273H6.823v16.036z" fill="#2F70DE"/></svg>
            {{ textContent.confirmButton }}
          </BaseButton>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.modal-dialog > .modal-content {
  .modal-text-main {
    color: $color-black-one;
    font-size: 28px;
    font-style: normal;
    font-weight: 900;
    letter-spacing: -0.233333px;
    line-height: 28px;
    margin-left: 3rem;
    margin-right: 3rem;
    margin-top: 2rem;
    text-align: center;
  }
  .modal-text-second {
    color: $color-black-one;
    font-size: 18px;
    font-weight: 800;
    letter-spacing: -0.233333px;
    text-align: center;
  }
  .modal-text-third {
    color: $color-black-one;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: -0.233333px;
    text-align: center;
  }
  .actions {
    display: flex;
    justify-content: space-around;
    padding-bottom: 2rem;
    padding-top: 2rem;
    .button {
      align-items: center;
      display: flex;
      height: 4rem;
      justify-content: center;
    }
    svg {
      margin-right: 1rem;
      path {
        fill: white;
      }
    }
  }
  .error {
    color: red;
  }
}

::v-deep .modal-dialog {
  min-width: 40%;
  .modal-content {
    background: $color-white;
    border-radius: 12px !important;
    box-shadow: 0 4px 8px rgba($color-black-wo-rgb, 0.08);
  }
}

::v-deep .modal {
  .modal-header {
    background-color: white;
    border-bottom: none;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 4rem 4rem 0;

    .close {
      color: black;
    }

    .modal-title {
      color: black;
    }
  }

  .modal-body {
    padding: 0 3.3rem 1.5rem;
  }
}
</style>
